"use client";

import { createContext } from "react";
import { ModalState, ModalDispatch, xGlobalModal } from "./types";
export const ModalStateContext = createContext<ModalState | undefined>(
  undefined
);
export const ModalDispatchContext = createContext<ModalDispatch | undefined>(
  undefined
);
export const GlobalStateContext = createContext<xGlobalModal | undefined>(
  undefined
);
